/**
 * list-filter-variables — zmienne w wartościach filtrów list („szybkie filtry", filtry stałe).
 *
 * Wartość filtra zapisana w widoku jest wspólna dla wszystkich użytkowników. Znacznik `@userId`
 * oznacza OSOBĘ ZALOGOWANĄ w chwili oglądania listy — nie tego, kto filtr ustawił. Admin zapisuje
 * jeden filtr („Opiekun = @userId"), a każdy, kto otworzy listę, widzi w nim swoje rekordy.
 * Podmieniamy znacznik tuż przed wysłaniem zapytania na id zalogowanego użytkownika.
 *
 * `@ja` — dawny zapis tego samego znacznika (pierwsza wersja), czytany nadal, żeby filtry zapisane
 * przed zmianą nie przestały działać. Nowe filtry zapisują `@userId`.
 *
 * To WYGODA budowania widoków, nie kontrola dostępu: użytkownik może filtr zdjąć. O tym, co wolno
 * widzieć, rozstrzygają uprawnienia (widoczność zaawansowana).
 */

/** Znacznik „zalogowany użytkownik" zapisywany w wartości filtra. */
export const CURRENT_USER_FILTER_TOKEN = '@userId';

/** Dawny zapis znacznika — tylko do odczytu filtrów zapisanych przed zmianą. */
const LEGACY_CURRENT_USER_FILTER_TOKEN = '@ja';

const CURRENT_USER_TOKENS: ReadonlySet<string> = new Set([
  CURRENT_USER_FILTER_TOKEN.toLowerCase(),
  LEGACY_CURRENT_USER_FILTER_TOKEN,
]);

/**
 * Czy wartość filtra to znacznik „zalogowany użytkownik" (`@userId` albo dawne `@ja`), bez
 * rozróżniania wielkości liter i spacji na brzegach.
 */
export function isCurrentUserFilterToken(value: unknown): boolean {
  return typeof value === 'string' && CURRENT_USER_TOKENS.has(value.trim().toLowerCase());
}

/**
 * Podstawia znacznik „zalogowany użytkownik" identyfikatorem tej osoby. Inne wartości zwraca bez
 * zmian. Gdy id nieznane (sesja jeszcze się ładuje) zwraca `null` — wołający POMIJA taki warunek
 * zamiast wysyłać do serwera nierozwiązany znacznik, który nie pasowałby do żadnego rekordu.
 */
export function resolveFilterVariable(value: unknown, userId: string | null | undefined): unknown {
  if (!isCurrentUserFilterToken(value)) return value;
  return userId ? userId : null;
}
